import React from 'react';
import { Container } from 'react-bootstrap'
import { Content} from './styles'
import Slider from 'react-slick';
import Segments from './Segments';
import {NextArrowCarusel,  PrevArrowCarusel} from '~/shared/ArrowsCarousel'

const MarketOperate = () => {

    const settingSegments = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        rows: 2,
        autoplay: true,
        autoplaySpeed: 2000,
        centerPadding: "60px",
        nextArrow: <NextArrowCarusel />,
        prevArrow: <PrevArrowCarusel />,

        responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                rows: 1
              }
            },

            {
                breakpoint: 414,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  rows: 1
                }
              }
        ],

      }


  return (
      <Container>
          <Content id="galeria">
            <div className="marketb-title">
                    <p>Mercado<strong> que atuamos</strong></p>
            </div>

            <div className="segments">
                <Slider {...settingSegments}>
                    <Segments image="/images/matterport-3.jpg"  text="Imobiliário"/>
                    <Segments image="/images/hotelaria.jpg"  text="Hotelaria"/>
                    <Segments image="/images/veiculo.jpg"  text="Veículos"/>
                    <Segments image="/images/gastronomia.jpg"  text="Gastronomia"/>
                    <Segments image="/images/ecomerce.jpg"  text="E-commerce"/>
                    <Segments image="/images/outros_.jpg"  text="Outros"/>

                </Slider>
            </div>
         </Content>
      </Container>
  )
}

export default MarketOperate;
